<template>
  <v-app>
    <confirmation-dialog />
    <error-dialog />
    <router-view />
  </v-app>
</template>

<script setup lang="ts">
import ConfirmationDialog from "./dialogs/ConfirmationDialog.vue";
import ErrorDialog from "./dialogs/ErrorDialog.vue";
</script>

<style scoped></style>
